import { gfmTable } from "micromark-extension-gfm-table";
import { gfmTableFromMarkdown } from "mdast-util-gfm-table";

/**
 * Alleen het TABELDEEL van GFM aanzetten, en niets anders.
 *
 * **DE MELDING VAN FRANK, 24 AUGUSTUS 2026:** een markdown-tabel in een gewoon
 * antwoord wordt platgeslagen tot een doorlopende tekstbrei.
 *
 * **DE OORZAAK, en die was al bekend uit R40.** `MessageBubble` rendert met
 * `react-markdown`, en gewone CommonMark kent geen tabellen. Drie tabelregels
 * worden dan een alinea. R40 heeft daar EEN uitzondering op gemaakt, voor het
 * blok achter het merkteken `[uit de tabel]`; alles daarbuiten bleef plat.
 * Gemeten in Franks database: 12 berichten dragen een tabel, waarvan er 5 dat
 * merkteken hebben. De overige 7 tabellen werden platgeslagen.
 *
 * **WAAROM ALLEEN TABELLEN EN NIET DE VOLLE `remark-gfm`. FRANKS BESLUIT VAN
 * 24 AUGUSTUS 2026, EN ZIJN REDEN STAAT ERBIJ.** `remark-gfm` zet in een klap
 * ook doorhalen, taaklijstjes, voetnoten, een tagfilter EN AUTOLINKS aan.
 * Gemeten wat dat aan BESTAANDE berichten zou veranderen:
 *
 *   doorhalen `~~`      0 berichten   geen gevolg
 *   taaklijstjes        0 berichten   geen gevolg
 *   kale URL's         16 stuks in 15 berichten -> zouden KLIKBAAR worden
 *
 * Franks woorden: "dat is precies een verandering die ik niet heb gevraagd".
 * Een adres dat het model heeft geproduceerd wordt dan vanzelf een aanklikbare
 * link, en dat is een besluit dat bij hem hoort en niet bij een plugin die je
 * voor de tabellen installeert.
 *
 * Kosten van deze keuze, gemeten: **3 nieuwe pakketten in plaats van 11**, en
 * geen enkele bestaande versie schuift op. De hele onderbouw (`micromark`,
 * `mdast-util-from-markdown`, `devlop`, de `micromark-util-*`) stond er al via
 * `react-markdown`.
 *
 * **ER BESTAAN NU TWEE TABELWEGEN NAAST ELKAAR, EN DAT IS MET OPZET.**
 * Zie `lib/tabelblok.js`: het R40-blok houdt zijn eigen render, want het draagt
 * een eis die GFM niet kent en ook niet kan kennen: **cellen worden afgekapt op
 * 300 tekens**, gelijk aan `MAX_CEL_TEKENS` en `KAPMERK` in
 * `backend/services/table_lookup.py`. Die afkapping bestaat omdat een cel uit de
 * kennisbank honderden tekens lang kan zijn en het scherm dan onleesbaar wordt.
 * Zou het R40-blok voortaan door deze plugin lopen, dan verdween die afkapping
 * zonder dat iemand daarom heeft gevraagd. Frank heeft op 24 augustus 2026
 * besloten het blok te laten staan.
 *
 * De scheiding is scherp en niet vaag: `splits()` haalt het R40-blok ERUIT
 * voordat de rest naar `react-markdown` gaat, dus de twee wegen raken elkaar
 * nergens. Een tabel die NIET achter het merkteken staat, komt hier terecht.
 */
export default function remarkTabellen() {
  const data = this.data();
  const micromark = data.micromarkExtensions || (data.micromarkExtensions = []);
  const vanMarkdown = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
  // **DEZE TWEE HAAKJES ZIJN HET HELE VERSCHIL, en ik ben er in de eerste
  // versie ingetrapt.** `gfmTable` en `gfmTableFromMarkdown` zijn FABRIEKEN en
  // geen constanten: ongeroepen doorgeven levert een plugin op die netjes
  // draait, niets doet, en geen fout geeft. `remark-gfm` doet het zelf ook zo
  // (`gfm(settings)`, `gfmFromMarkdown()`), en dat is nagekeken in zijn bron in
  // plaats van geraden. Gevonden door `meting/tabellen.mjs`: de bronscan in
  // jest stond groen, want de plugin WERD geimporteerd en WERD meegegeven.
  micromark.push(gfmTable());
  vanMarkdown.push(gfmTableFromMarkdown());
}
